export default "__VITE_ASSET__nHHK8y74__"